/**
 * Deprecated
 * Use simple radio-button css class
 * Example:
 * `
 * <div class="radio-button-group">
 *    <label class="radio-button">
 *        <input type="radio"
 *               [value]="0"
 *               [name]="'radioName'"/>
 *        <div>Some option</div>
 *    </label>
 *    <label class="radio-button">
 *        <input type="radio"
 *               [value]="2"
 *               [name]="'radioName'"/>
 *        <div>Another option</div>
 *    </label>
 * </div>
 * `
 * */

import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-radio-item',
  templateUrl: './ui-radio-item.component.html'
})
export class UiRadioItemComponent {
  @Input() value: any;
  @Input() checked: boolean;
  @Input() name: string;

  @Output() onClick = new EventEmitter<any>();
}
